module.exports = require("./lib/menubuilder");



//////////////////
// WEBPACK FOOTER
// ./~/menu-builder/index.js
// module id = 115
// module chunks = 0